import API from "@/api/api";
import { DATA_API_SERVICE } from "@/appConfig";
import { RealmAPIResponse } from "@/classes/realm";

export async function getRealms() {
  try {
    const response = await API.get<RealmAPIResponse>(`${DATA_API_SERVICE}/realm`);
    return response.data.realms;
  } catch (e) {
    return [];
  }
}
